var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7778 4.83398H3.22222C1.99492 4.83398 1 5.82891 1 7.05621V19.2784C1 20.5057 1.99492 21.5007 3.22222 21.5007H18.7778C20.0051 21.5007 21 20.5057 21 19.2784V7.05621C21 5.82891 20.0051 4.83398 18.7778 4.83398Z",
    stroke: "#989898",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.27843C1 7.18287 1 6.13621 1.65111 5.4851C2.30222 4.83398 3.34889 4.83398 5.44444 4.83398H16.5556C18.6511 4.83398 19.6978 4.83398 20.3489 5.4851C21 6.13621 21 7.18287 21 9.27843H1Z",
    fill: "#989898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44434 1.5V4.83333M16.5554 1.5V4.83333",
    stroke: "#989898",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.735130ac9fe60a13716adecb4bdc8d35.svg";
export { ForwardRef as ReactComponent };